module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout mdl-js-layout mdl-layout--fixed-header"
  }, [_c('section-header'), _vm._v(" "), _c('section-drawer-menu'), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content mdl-color--blue-grey-800"
  }, [_c('router-view', {
    staticClass: "view"
  }), _vm._v(" "), _vm._m(1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-theatre"
  }, [_c('img', {
    staticClass: "adv-fullpic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-snackbar mdl-js-snackbar",
    attrs: {
      "id": "snackbar",
      "aria-live": "assertive",
      "aria-atomic": "true",
      "aria-relevant": "text"
    }
  }, [_c('div', {
    staticClass: "mdl-snackbar__text"
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-snackbar__action",
    attrs: {
      "type": "button"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d24bc5f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 308
// module chunks = 0